import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';
import Editable from "react-x-editable";

class SyncList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            codes: "",
            isrcs: "",      
            filtered: [],
            filter: {title:"",genre:""}
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
}

ensureDataFetched() {
    const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
    // this.props.requestWeatherForecasts(startDateIndex);
   // this.props.getData();
 
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;//this.props.filtered;
        let insertNewFilter = 1;



        if (filtered.length) {
            filtered.forEach((filter, i) => {
                if (filter["id"] === accessor) {
                    if (value === "" || value === null) filtered.splice(i, 1);
                    else filter["value"] = value;
                    insertNewFilter = 0;
                }
            });
        }

        if (insertNewFilter) {
            filtered.push({ id: accessor, value: value });
        }

        //this.props.setCatalogueFilter(filtered);
        this.setState({ filtered: filtered });
    };

    onUPCChange(e) {
        //var _filter = this.state.filter;
        //_filter.title = e.target.value;
        //this.setState({ filter: _filter });
       
        this.props.setFilterTitle(e.target.value);
    }

    onGenreChange(e) {
        //var _filter = this.state.filter;
        //_filter.genre = e.target.value;
        //this.setState({ filter: _filter });
        this.props.setFilterGenre(e.target.value);
    }
    onISRCChange(e) {
        //var _filter = this.state.filter;
        //_filter.genre = e.target.value;
        //this.setState({ filter: _filter });
        this.props.setFilterISRC(e.target.value);
    }

    

    selectListType(data) {

        this.setState(
            { selectedOption : data });

    }

    setPropValue(id, name, _prop) {

        this.props.setProductProp(id, _prop, name.newValue);

    }

    sanitizeString(str) {

        if (str) {
            str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "");
            return str.trim();
        }
        return str;
   
     }

render() {
    const access = localStorage.getItem("accessToken");
  //  console.info(this.props.upcData);
    let url = this.props ? this.props.audioURL : '';
  

    
    

    return (
        <div>       
            <Tabs selectedIndex={this.props.tabIndexSync} onSelect={tabIndex => this.props.setTabSync(tabIndex)}>
            <TabList>
                    <Tab>Search Tracks</Tab>
                    <Tab>Selected Tracks {this.props.tempSyncList !== null && this.props.tempSyncList.length > 0 ? "("+this.props.tempSyncList.length+")" : ""}</Tab>
            </TabList>
                <TabPanel>

                    <br/>
                    <div className="row">
                        <div className="col-sm-4">
                            <input type="text" disabled={this.props.isLoadingSyncData} className="form-control" id="shortlistISRC" placeholder={"Title"} onChange={(e) => this.onUPCChange(e)} value={this.props.syncfilterSelected.title} ></input>
                        </div>
                        <div className="col-sm-4">
                            <input type="text" disabled={this.props.isLoadingSyncData} className="form-control" id="shortlistISRC" placeholder={"Genre"} onChange={(e) => this.onGenreChange(e)} value={this.props.syncfilterSelected.genre} ></input>

                        </div> <div className="col-sm-4">
                            <input type="text" disabled={this.props.isLoadingSyncData} className="form-control" id="shortlistISRC" placeholder={"ISRCS"} onChange={(e) => this.onISRCChange(e)} value={this.props.syncfilterSelected.isrcs} ></input>
                        </div>
                        
                    </div>
                    <br/>
                    <div className="col-sm-4">
                        <button disabled={(this.props.syncfilterSelected.genre === "" && this.props.syncfilterSelected.title === "" && this.props.syncfilterSelected.isrcs === "") || this.props.isLoadingSyncData} onClick={(e) => this.props.getSyncData(this.props.syncfilterSelected)}>Search</button></div>
                    <br />

                    <br />
                    <div className="row">
                        <div className="col-sm-12">
                            {this.props.syncData !== null && this.props.syncData.length > 0 ? <CSVLink data={this.props.syncData} filename={"syncData-List.csv"}>Download CSV</CSVLink> : ""}
                            <br />
                           
                            {this.props.syncData != null && this.props.syncData.length > 0 ? renderReactTable(this.props.syncData, this.props, this, access) : ""}
                        </div>
                    </div>



                </TabPanel>
                <TabPanel>
                    <br />
                    {this.props.tempSyncList !== null && this.props.tempSyncList.length > 0 ? <CSVLink  data={this.props.tempSyncList} filename={"Selected-syncData-List.csv"}>Download Selected Assets CSV</CSVLink> : ""}
                    {this.props.tempSyncList != null && this.props.tempSyncList.length > 0 ? renderReactTable(this.props.tempSyncList, this.props, this, access) : ""}

                </TabPanel>

            </Tabs>
           
               

            </div>
          
     
            
            
          

        
    );
}
}





function renderReactTable(data, props,main, access) {

   

    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {

                style: {
                    background: props.tempSyncList && props.tempSyncList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempSyncList && props.tempSyncList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',

                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}

            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;
                if (typeof filter.value === "object") {
                    return row[id] !== undefined || row[id] !== null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}


            columns={[
                {
                    Header: "Basic Data",
                    columns: [
                        {
                            Header: "ISRC",
                            accessor: "isrc",
                            Cell: row => (
                                <span style={{ cursor: 'pointer' }} onClick={() => props.selectSyncTrack(row.value)}> {props.tempSyncList && props.tempSyncList.filter(t => t.isrc === row.value).length > 0 ? row.value : row.value}</span>
                            )
                        },
                        {
                            Header: "Audio",
                            accessor: "fugaID",
                            Cell: row => (
                                <button onClick={() => props.setAudioUrl(row.value)}> {props.audioURL === row.value ? "Playing" : "Play"}</button>
                            ),
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },
                        {
                            Header: "Download",
                            accessor: "fugaID",
                            Cell: row => (<a href={"/api/data/getaudio?fugaid=" + row.value + "&access_token=" + access} download={row.original.isrc + "-" + main.sanitizeString(row.original.name) + "-" + main.sanitizeString(row.original.displayArtist) + ".mp3"
                        } > mp3</a >),
                            Filter: ({ filter, onChange }) => {
                                return("")
                            }
                        },
                        {
                            Header: "Download Original",
                            accessor: "fugaID",
                            Cell: row => (<a href={"/api/data/getaudioOriginal?fugaid=" + row.value + "&access_token=" + access} download={row.original.isrc + "-" + main.sanitizeString(row.original.name) + "-" + main.sanitizeString(row.original.displayArtist) + ".wav"
                            } > wav</a >),
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },
                        {
                            Header: "Title",
                            accessor: "name"
                        },
                        {
                            Header: "Artist",
                            accessor: "displayArtist"
                        },
                        {
                            Header: "Original Artist",
                            accessor: "originalArtist"
                        },
                        {
                            Header: "Version",
                            accessor: "version"
                        },
                        {
                            Header: "Genre",
                            accessor: "genre",                          
                        },
                        {
                            Header: "SubGenre",
                            accessor: "subgenre"
                        },
                        {
                            Header: "Alt Genre",
                            accessor: "alt_genre",                          
                        },
                        {
                            Header: "Alt SubGenre",
                            accessor: "alt_subgenre"
                        },
                        {
                            Header: "Catalog",
                            accessor: "catalog",
                           
                        },
                        {
                            Header: "Recording Year",
                            accessor: "recordingYear"
                        },
                        {
                            Header: "Language",
                            accessor: "lop"
                        },
                        {
                            Header: "Tags",
                            accessor: "tag_visible",
                            Cell: row => <div><span title={row.value}>{row.value}</span></div>

                        },
                        {
                            Header: "Tags Hidden",
                            accessor: "tag_hidden",
                            Cell: row => <div><span title={row.value}>{row.value}</span></div>

                        },                        
                        {
                            Header: "Products",
                            accessor: "products"
                        },


                    ]
                }
            ]}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};




export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(SyncList);



// WEBPACK FOOTER //
// ./src/components/Sync.js